import { render } from "./PersonalPassword.vue?vue&type=template&id=5bd41cc1"
import script from "./PersonalPassword.vue?vue&type=script&lang=js"
export * from "./PersonalPassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__